module.exports = __webpack_public_path__ + "img/compact-excavator.0249165.png";